import { render, staticRenderFns } from "./MobileBottomTabs.vue?vue&type=template&id=eeb22cda&"
import script from "./MobileBottomTabs.vue?vue&type=script&lang=js&"
export * from "./MobileBottomTabs.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomTabs.vue?vue&type=style&index=0&id=eeb22cda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports